export default function SmallButton(props){
    return(
        <button 
            className={`flex justify-center py-1 px-3 border rounded-full w-full 
                ${ props?.visible ? 'block' : 'hidden' }
                hover:bg-black hover:text-white
                transition-all text-sm ${ props?.className }
            `}
            onClick={props?.onClick}
        >
            {props?.buttonName}
        </button>
    )
}